<template>
  <div class="supplied-coupon">
    <div class="clear">
      <h2 class="paging-title">待领取优惠券</h2>
    </div>
    <ul class="list">
      <li v-for="(item,index) in couponList" :key="index">
        <div class="dt">
          <div class="type-name">
            <div>
              {{item.CouponTypeStr}}
              <template v-if="item.CouponType !=3 || (item.CouponType ==1 && item.UseScope!=5)">
                —{{item.UseScopeStr}}
              </template>
            </div>
              <template v-if="item.CouponType !=3">
              {{item.UsePermission ==6?'自营工单':item.UsePermission ==1?'众包工单':''}}
            </template>
          </div>
          <div class="count" v-if="item.CouponMode ==1">¥{{item.FullReduceOffAmount}}</div>
          <div class="count" v-if="item.CouponMode ==2">{{item.DiscountRate*10}} <span class="unit">折</span></div>
          <div class="count" v-if="item.CouponMode ==3">¥{{item.OffAmount}}</div>
          <div class="desc">{{item.CouponTypeStr}}</div>
          <!-- <span class="expire">3日内到期</span> -->
        </div>
        <div class="dd">
          <div class="title" v-if="item.CouponMode ==1">满{{item.FullReduceLimitAmount}}立减{{item.FullReduceOffAmount}}</div>
          <div class="title" v-if="item.CouponMode ==2">{{item.DiscountRate*10}}折</div>
          <div class="title" v-if="item.CouponMode ==3">立减{{item.OffAmount}}</div>
          <span class="time" v-if="item.EffectivityDateType==1">有效期至{{item.EffectivityEndTime | formatTime}}</span>
          <button class="btn-primary" @click="receive(item)">领取</button>
        </div>
      </li>
    </ul>
    <i class="icon-empty" v-if="couponList.length==0"></i>
  </div>
</template>
<script>
import {
    GetCouponList,
    DrewUserCouPons,
} from '@/scripts/api.js'
import {mapState} from 'vuex'
export default {
  data(){
    return{
      couponList:[],
    }
  },
	computed:{
		...mapState({
			userInfo:state=>state.userInfo,
		})
	},
  filters:{
    formatTime(value){
      if(value){
        return value.substr(0,10);
      }
      return '';
    }
  },
  watch:{
    userInfo(value){
      if(value && value.LoginAccountId){
        this.pageInit();
      }
    }
  },
  created() {
    this.pageInit();
  },
  methods: {
    pageInit(){
      let params={
        PageNum:1,
        PageSize:100,
        platform:'pcweb',
      }
      if(this.userInfo && this.userInfo.LoginAccountType==1){
        params['UserId']=this.userInfo.LoginAccountId;
      }else if(this.userInfo && this.userInfo.LoginAccountType==2){
        params['CompanyId']=this.userInfo.LoginAccountId;
      }else{
        return;
      }
      GetCouponList(params).then(r=>{
        if(r.Result==1){
          this.couponList=r.Data || [];
        }else{
          this.$toast(r.Message);
        }
      })
    },
    //领取
    receive(item){
      DrewUserCouPons({
        UserCode:this.userInfo.UserCode,
        ConfigCouposID:item.Id,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1){
          this.$toast('领取成功！');
          this.pageInit();
        }else{
          this.$toast(r.Message);
        }
      })
    }
  },
}
</script>
<style lang="scss">
.supplied-coupon{
  .list{
    overflow: hidden;
    margin-top: 20px;
    >li{
      float: left;
      margin-right: 10px;
      margin-bottom: 10px;
      border-radius: 10px;
      overflow: hidden;
      background-color: #f9f9f9;
      width: 240px;
      height: 280px;
      position: relative;
      &:nth-child(4n){
        margin-right: 0;
      }
    }
    .dt{
      height: 120px;
      padding: 5px 13px;
      background:  url('~@/assets/coupon/bg-active.png') no-repeat center top;
      background-size: contain;
      padding-top: 40px;
      .type-name{
        font-size: 12px;
        color: #fff;
        line-height: 20px;
        text-align: left;
        position: absolute;
        left: 10px;
        top: 5px;
      }
      .count{
        text-align: center;
        font-size: 48px;
        line-height: 48px;
        color: #fff;
        font-weight: bold;
        font-family: "DIN-Regular";
        .unit{
          font-size: 16px;
          line-height: 24px;
          font-weight: normal;
        }
      }
      .desc{
        text-align: center;
        font-size: 18px;
        color: #fff;
        line-height: 20px;
      }
      .expire{
        position: absolute;
        right: -33px;
        top: -23px;
        font-size: 12px;
        color: #fff;
        line-height: 104px;
        text-align: center;
        width: 80px;
        height: 60px;
        background-color: #00B4FF;
        white-space: nowrap;
        transform: rotate(45deg);
      }
    }
    .dd{
      height: 160px;
      padding: 15px;
      .title{
        font-size: 18px;
        color: #333;
        line-height: 30px;
        font-weight: bold;
      }
      .time{
        display: block;
        font-size: 16px;
        line-height: 24px;
        color: #999;
        margin-top: 6px;
        white-space: nowrap;
      }
      .btn-primary{
        display: block;
        width: 100px;
        height: 30px;
        text-align: center;
        font-size: 14px;
        margin: 20px auto 10px;
        border-radius: 2px;
        background-color: #f75959;
        color: #fff;
        cursor: pointer;
        position: absolute;
        left: 50%;
        bottom: 20px;
        margin-left: -50px;
        &:hover{
          background-color: #ff3838;
        }
      }
    }
  }
}
</style>